import React from 'react';
import styled from 'styled-components';
import Modal from '../modal/Modal';
import { useTranslation } from 'react-i18next';
import { LeadsAPI } from '../../api/public';

const Title = styled.h2`margin:0 0 8px;`;
const Row   = styled.div`
  display:grid; grid-template-columns:1fr 1fr; gap:12px;
  @media (max-width:720px){ grid-template-columns:1fr; }
`;
const Field = styled.div`
  display:flex; flex-direction:column; gap:6px;
  ${p => p.$full && 'grid-column: 1 / -1;'}
`;
const Input = styled.input`
  width:100%; padding:12px 14px; border-radius:12px;
  border:1px solid var(--bdr); background:var(--card); color:inherit;
`;
const Text  = styled.textarea`
  width:100%; min-height:110px; padding:12px 14px; border-radius:12px;
  border:1px solid var(--bdr); background:var(--card); color:inherit;
`;
const Actions = styled.div`margin-top:16px; display:flex; gap:10px; justify-content:flex-end;`;
const Btn = styled.button`
  padding:12px 16px; border-radius:12px; font-weight:700;
  border:1px solid var(--bdr); background:var(--primary); color:var(--primaryFg);
`;
const OkBox = styled.div`
  margin-top: 8px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid #2e7d32;
  background: rgba(46, 125, 50, .08);
  color: #2e7d32;
`;

/** Оранжевая плашка под надпись */
const InfoNote = styled.div`
  margin: 6px 0 12px;
  padding: 10px 12px;
  border-radius: 12px;
  /* берём брендовый var(--primary), если нет — резервный #C7903E */
  color: var(--primary, #C7903E);
  border: 1px solid currentColor;
  /* мягкий фон как у полей/кнопки */
  background: rgba(199, 144, 62, .10);
  font-size: 0.95rem;
`;

export default function LeadModal({ open, onClose }) {
  const { t } = useTranslation();

  const [name, setName] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [comment, setComment] = React.useState('');
  const [done, setDone] = React.useState(false);
  const [error, setError] = React.useState('');

  const closeTimerRef = React.useRef(null);

  React.useEffect(() => {
    if (!open) {
      setDone(false);
      setError('');
      if (closeTimerRef.current) { clearTimeout(closeTimerRef.current); closeTimerRef.current = null; }
      return;
    }
    setDone(false);
    setError('');
    return () => {
      if (closeTimerRef.current) { clearTimeout(closeTimerRef.current); closeTimerRef.current = null; }
    };
  }, [open]);

  const submit = async (e) => {
    e.preventDefault();
    const digits = (phone || '').replace(/\D/g, '');
    const valid = digits.length >= 11;
    if (!name.trim() || !valid) { setError('Укажите имя и телефон'); return; }
    setError('');

    const payload = {
      first_name: name.trim(),
      phone,
      email: email || undefined,
      message: comment || undefined,
      source_page: typeof window !== 'undefined' ? window.location.pathname : undefined,
      utm_source: localStorage.getItem('utm_source') || undefined,
      utm_medium: localStorage.getItem('utm_medium') || undefined,
      utm_campaign: localStorage.getItem('utm_campaign') || undefined,
      device_id: localStorage.getItem('device_id') || undefined,
      consent_privacy: true,
      consent_marketing: false,
    };

    try {
      await LeadsAPI.consultation(payload);
      setDone(true);
      closeTimerRef.current = setTimeout(() => {
        closeTimerRef.current = null;
        onClose?.();
        setName(''); setPhone(''); setEmail(''); setComment('');
      }, 5000);
    } catch (err) {
      setError(String(err?.message || err));
    }
  };

  const handleClose = () => {
    if (closeTimerRef.current) { clearTimeout(closeTimerRef.current); closeTimerRef.current = null; }
    onClose?.();
    setName(''); setPhone(''); setEmail(''); setComment('');
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Title>{t('quiz.modalTitle')}</Title>

      {/* Оранжевая надпись */}
      <InfoNote>{t('quiz.notice')}</InfoNote>

      {done ? (
        <OkBox>{t('quiz.okMsg')}</OkBox>
      ) : (
        <form onSubmit={submit}>
          <Row>
            <Field>
              <Input placeholder={t('quiz.placeholders.name')} value={name} onChange={e=>setName(e.target.value)} />
            </Field>
            <Field>
              <Input placeholder={t('quiz.placeholders.phone')} value={phone} onChange={e=>setPhone(e.target.value)} />
            </Field>
          </Row>

          {/* E-mail — во всю ширину */}
          <Row style={{marginTop:12}}>
            <Field $full>
              <Input placeholder={t('quiz.placeholders.email')} type="email" value={email} onChange={e=>setEmail(e.target.value)} />
            </Field>
          </Row>

          <Text placeholder={t('quiz.placeholders.comment')} value={comment} onChange={e=>setComment(e.target.value)} style={{marginTop:12}} />

          {error && <p style={{color:'#e66',margin:'8px 0 0'}}>{error}</p>}
          <Actions><Btn type="submit">{t('quiz.send')}</Btn></Actions>
        </form>
      )}
    </Modal>
  );
}
